"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStep = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const StepHeader_1 = require("../StepHeader/StepHeader");
const StepTitleWrapper_1 = require("../StepTitleWrapper/StepTitleWrapper");
const WrapperSubstep_1 = require("../WrapperSubstep/WrapperSubstep");
const helpers_1 = require("../../../helpers");
exports.StyledStep = styled_components_1.default.div `
    margin: 0;
    padding: 0;
    max-width: 848px;

    ${WrapperSubstep_1.WrapperSubstep.selector}:before {
        align-items: center;
        content: counter(substep);
        counter-increment: substep;
        display: flex;
        font-size: ${helpers_1.FONT_SIZE_S};
        font-weight: ${helpers_1.BASE_FONT_NORMAL_WEIGHT};
        height: ${helpers_1.SPACING_L};
        justify-content: center;
        padding: 12px 0 0;
        position: absolute;
        width: ${helpers_1.SPACING_XXXL};
    }

    &:not(:first-child) ${StepHeader_1.StepHeader.selector} ${StepTitleWrapper_1.StepTitleWrapper.selector} {
        border-top: ${helpers_1.BASE_BORDER_WIDTH} solid ${({ theme }) => theme.colorBorderMain};
    }

    ${WrapperSubstep_1.WrapperSubstep.selector}:last-child {
        padding-bottom: ${helpers_1.SPACING_S};
    }
`;
//# sourceMappingURL=Step.styles.js.map